import { createContext, useContext } from 'react';

/**
 * 필터 바텀시트가 별도 RN surface(modal)로 띄워졌을 때, 시트 내부 컴포넌트들이
 * 호출 screen의 navigation/route를 조작할 수 있도록 inject되는 override.
 *
 * - 일반(인라인) 시트 사용 시에는 null이고, 이 경우 컴포넌트는 자체 `useNavigation()` /
 *   `useRoute()`를 사용한다.
 * - modal surface로 띄울 때는 `BottomSheetHostScreen`의 FilterSheet 렌더러가 호출 screen
 *   기준 값을 주입한다.
 */
export type FilterSheetOverride = {
  setParams: (params: Record<string, unknown>) => void;
  routeParams: Record<string, unknown>;
};

const FilterSheetOverrideContext = createContext<FilterSheetOverride | null>(
  null,
);

export const FilterSheetOverrideProvider = FilterSheetOverrideContext.Provider;

export const useFilterSheetOverride = (): FilterSheetOverride | null =>
  useContext(FilterSheetOverrideContext);
